import { render, staticRenderFns } from "./statusTd.vue?vue&type=template&id=a94cd8fa"
import script from "./statusTd.vue?vue&type=script&lang=js"
export * from "./statusTd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports